module.exports = __webpack_public_path__ + "img/330434877.ad6af4a3.jpg";